import { render, staticRenderFns } from "./allocatableResources.vue?vue&type=template&id=77568567&"
import script from "./allocatableResources.vue?vue&type=script&lang=js&"
export * from "./allocatableResources.vue?vue&type=script&lang=js&"
import style0 from "./allocatableResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports